import { PropsWithChildren, ReactNode } from 'react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

type Props = PropsWithChildren & {
  message?: ReactNode;
};

export const EmptyState = ({ children, message }: Props) => {
  return (
    <div
      css={{
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <div
        css={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(4),
          textAlign: 'center',
          // TODO: Add styles that change the size of the empty state graphics
        }}
      >
        {children}
        {message && (
          <Text textAlign='center' css={{ color: theme.colors.neutral50, padding: theme.spacing(0, 1.5) }}>
            {message}
          </Text>
        )}
      </div>
    </div>
  );
};
